import { useEffect, useState } from "react";
import ReportFilters from "./ReportFilters";
import UserPerformanceReport from "../userReport/ReportDashboardv2"
import { useGetAssignUsersQuery } from "../../../store/services/assigningUsers";
import Apis from "../../../utils/apis";
import { API_AXIOS } from "../../../http/interceptor";

// import ReportDashboard from "./ReportDashboard";

export default function UserReportsPage() {
  const [users, setUsers] = useState([]);
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);

  const { data: allMembers = {} } = useGetAssignUsersQuery();

  const generateReport = async ({
    userId,
    leadType,
    startDate,
    endDate,
  }) => {
    try {
      setLoading(true);

      const params = new URLSearchParams({
        userId,
        ...(leadType && { leadType }),
        ...(startDate && { fromDate: startDate.toISOString() }),
        ...(endDate && { toDate: endDate.toISOString() }),
      });

      const res = await API_AXIOS.get(
        `${Apis.specificUserDetailedReport}?${params}`,
      ); //@@we are here
      const data = res.data?.data ?? [];

      setReport(data);
    }catch(err){

    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="space-y-6">
      <ReportFilters
        users={[]}
        loading={loading}
        onGenerate={generateReport}
      />

      <UserPerformanceReport reportData={report} />

      {/* {report && (
        <ReportDashboard report={report} />

      )} */}
    </div>
  );
}